import wallImage from '../images/wall.jpeg';
import woodImage from '../images/wood.jpeg';
import boardImage from '../images/pinboard.png';
import './Pinboard.css';
import DateComponent from './Datecomponent';
import { Link } from 'react-router-dom';
import React, { useState, useEffect} from 'react';
import About from './About';
import Projects from './Projects';
import Contact from './Contact';
import Earphones from './Earphones';

export default function Pinboard() {
  const containerStyle = {
    backgroundImage: `url(${wallImage})`,
  };

  const woodStyle = {
    backgroundImage: `url(${woodImage})`,
  };

  const boardStyle = {
    backgroundImage: `url(${boardImage})`,
  };

  const [formattedDateTime, setFormattedDateTime] = useState('');
  const [splitDateTime, setSplitDateTime] = useState('');
  const [about, setAbout] = useState(false);
  const [projects, setProjects] = useState(false);
  const [contact, setContact] = useState(false);
  const [earphones, setEarphones] = useState(false);

  const handleDateUpdate = (formattedDateTimeString) => {
    setFormattedDateTime(formattedDateTimeString);
  };

  const handleSplit = () => {
    const splitResult = formattedDateTime.split('  ');
    setSplitDateTime(splitResult);
  };

  // useEffect hook to run handleSplit at an interval
  useEffect(() => {
    const intervalId = setInterval(() => {
      handleSplit();
    }, 1000);

    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, );

  return (
    <div className="container" style={{ ...containerStyle, height: '720px', padding: '100px 0px 0px' }}>
      <div className="above">
        <img src="images/kahna.png" alt="Kahna" width="100" height="100" className="kahna" />
        <div className="cal">
          <p id='date' style={{margin: '-10px 10px', fontSize: '32px'}}>{splitDateTime[0]}</p>
          <img src="images/calendar.png" alt="Calendar" width="100" height="100" className="calendar" />
        </div>
        <img src="images/penstand.png" alt="Pen stand" width="100" height="100" className="penstand" />
        <div className="name">
        <img src="images/riya.png" alt="riya" width="100" height="100" id="riya" />
        <img src="images/sachdeva.png" alt="sachdeva" width="100" height="100" id="sachdeva" />
        </div>
        <img src="images/mug.png" alt="mug" width="100" height="100" className="mug" />
        <div className="time">
          <p id='hrs'>{splitDateTime[1]}</p>
          <img src="images/clock.png" alt="clock" width="100" height="100" className="clock" />
        </div>
      </div>
      <div className="wood" style={{ ...woodStyle, height: '600px', padding: '70px 0px 0px' }}>
        <div className="about2" style={{filter: 'none'}}>
          {about && <About setAbout={setAbout}/> }
          {projects && <Projects setProjects={setProjects}/>}
          {contact && <Contact setContact={setContact}/>}
          {earphones && <Earphones setEarphones={setEarphones}/>}
        </div>
        <div className="board" style={{ ...boardStyle, height: '400px', 'filter': (about || contact || projects || earphones) ? 'blur(6px)' : 'none' }}>
        
          <div className="polaroids">
            <img src="images/lana.png" alt="Lana" width="140" height="170" className="lana" />
            <img src="images/nf.png" alt="NF" width="140" height="170" className="nf" />
          </div>
          <img src="images/vangogh.png" alt="Van Gogh's Painting" width="200" height="170" className="vango" />

          <div className="notes">
            <div className="sticky_note">
              <img src="images/sticky_note.png" alt="About" width="200" height="200" className="s1" />
              <Link id="note-text1" to='/' onClick={() => setAbout(true)}>About</Link>
              
            </div>
            <div className="sticky_note">
              <img src="images/sticky_note2.png" alt="Projects" width="200" height="200" className="s2" />
              <Link id="note-text2" to='/' onClick={()=> setProjects(true)}>Projects</Link>
            </div>
            <div className="sticky_note">
              <img src="images/sticky_note3.png" alt="Contact" width="200" height="200" className="s3" />
              <Link id="note-text3" to='/' onClick={() => setContact(true)}>Contact</Link>
            </div>
            <div className="earphones">
            <Link to="/" onClick={() => setEarphones(true)}><img src="images/earphones.png" className="earphones" alt=""/></Link>
            </div>
          </div>
          <Link to="https://proceedings.neurips.cc/paper_files/paper/2017/file/3f5ee243547dee91fbd053c1c4a845aa-Paper.pdf" target='_blank'><img src="images/bookmark.png" alt="bookmark" width="200" height="200" className="bookmark" /></Link>
          <img src="images/pin.png" alt="pin" width="20" height="20" className="pin" />
        </div>
        <img src="images/socket.png" alt="socket" width="400" height="250" className='socket'/>
      </div>
      <DateComponent onUpdate={handleDateUpdate} />
    </div>
  );
}
